/* eslint-disable react/prop-types */
import React, { memo, useRef } from 'react';
import PropTypes from 'prop-types';
import GenericButton from '../common/GenericButton';
import DynamicDataGrid from '../common/DynamicDataGrid/DynamicDataGrid';
import deleteIcon from '../../images/small-x-icon_l.png';
// import PortalModal from '../common/Modal/PortalModal';

// const modalStyle = {
//   top: '5%',
//   marginTop: '25%',
//   width: '50%',
//   height: '400px',
//   left: '30%',
// };

function CacOpenProjectModalContent({
  rowData, rowSelectionType, handleLoadCac,
}) {
  const [rowsClicked, setRowsClicked] = React.useState(false);
  const savedCrosstabGrid = useRef();

  const handleConfirmDelete = () => {
    // const savedCrosstabGridObj = savedCrosstabGrid.current;
    // if (savedCrosstabGridObj.getSelectedEntries()[0]) {
    //   // this.confirmDeleteModal.show();
    // }
  };

  const deleteHandler = () => {
    handleConfirmDelete();
  };

  const getSavedCrosstabColumns = () => {
    return [
      { key: 'title', name: 'Name', sortable: true },
      {
        key: 'lastModified',
        sortKey: 'lastModifiedSortable',
        name: 'Updated',
        sortable: true,
        formatter: props => (
          <div>
            {props.value}
            <button className="btn-x" type="button" onClick={() => deleteHandler()}>
              <img title="Delete" src={deleteIcon} alt="delete" />{' '}
            </button>
          </div>
        ),
      },
    ];
  };

  const handleLoadCrosstab = () => {
    const savedCrosstabGridObj = savedCrosstabGrid.current.decoratedRef.current;
    const entries = savedCrosstabGridObj.getSelectedEntries();
    handleLoadCac(entries);
  };

  const isBtnDisabled = () => {
    if (savedCrosstabGrid.current) {
      return savedCrosstabGrid.current.decoratedRef.current.getSelectedEntries().length === 0 || false
    }
    return true
  }

  const clickHandler = () => {
    setRowsClicked(!rowsClicked)
  }

  // const handleDeleteCrosstab = () => {
  //   const savedCrosstabGridObj = this.savedCrosstabGrid.getDecoratedComponentInstance();
  //   if (savedCrosstabGridObj.getSelectedEntries()[0]) {
  //     const id = savedCrosstabGridObj.getSelectedEntries()[0].id;
  //     this.props.crosstabActions.deleteSavedCrosstabs(
  //       this.props.loginResponse.data.token,
  //       this.props.loginResponse.data.uid,
  //       this.props.activeAccountId,
  //       id,
  //     );
  //   }
  //   this.confirmDeleteModal.hide();
  // };

  // const closeLoadCrosstabPopup = () => closeLoadCrosstabModal();

  return (
    <div>
      <div className="row">
        <div className="large-12">
          <DynamicDataGrid
            ref={savedCrosstabGrid}
            gridCategory="SaveCrosstabGrid"
            className="saved-crosstab-grid saved-crosstab-width"
            rows={rowData}
            columns={getSavedCrosstabColumns()}
            rowSelectionType={rowSelectionType}
            isCellSelectable
            minimunRows={5}
            clickHandler={clickHandler}
          />
        </div>
      </div>
      <div className="row">
        <div className="row-margin-top-10px">
          <div className="large-3 float-right text-right">
            <GenericButton
              name="Load"
              btnStyle="button load-btn"
              onBtnClick={() => handleLoadCrosstab()}
              btnDisabled={isBtnDisabled()}
            />
          </div>
        </div>
      </div>
      {/* <PortalModal
        title="Confirm Delete"
        // ref={node => (this.confirmDeleteModal = node)}
        dialogStyles={modalStyle}
      >
        <div className="large-12 columns">
          <div>
            Are you sure you want to delete this crosstab?
            <div className="row column">
              <div className="large-6 text-center columns">
                <GenericButton
                  name="Yes"
                  btnStyle="button button-125px"
                  onBtnClick={() => this.handleDeleteCrosstab()}
                />
              </div>
              <div className="large-6 text-center columns">
                <GenericButton
                  name="No"
                  btnStyle="button btn-cncl button-125px"
                  onBtnClick={() => this.confirmDeleteModal.hide()}
                />
              </div>
            </div>
          </div>
        </div>
      </PortalModal> */}
    </div>
  );
}

CacOpenProjectModalContent.propTypes = {
  rowData: PropTypes.arrayOf(PropTypes.object),
  // closeLoadCrosstabModal: PropTypes.func,
  handleLoadCac: PropTypes.func,
  rowSelectionType: PropTypes.string,
};

export default memo(CacOpenProjectModalContent);
